import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_bev_10: FaireProductEntity = {
  token: "nyc-bev-10",
  type: "product",
  name: "SoHo Cold-Pressed Juice",
  brandName: "SoHo Juice Bar",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/8fb4a9ff5cc7c0c0d2afc87eff190e471926c06931840d2956aeed437034d776.webp",
  priceDollars: 12,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/8fb4a9ff5cc7c0c0d2afc87eff190e471926c06931840d2956aeed437034d776.webp",
  weight: 1,
  dimensions: {
    width: 3,
    height: 8,
    depth: 3,
  },
  description: "Cold-pressed green juice from SoHo",
  categoryTokens: ["cat_food-beverages"],
  tags: ["nyc-local", "premium", "organic", "cold-pressed"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
